/**
 * Portal Permissions Module - Entry Point
 *
 * Registers dashboard pages with the portal page registry.
 * This file is loaded by the portal via the portalEntry() configuration.
 */

import { registerPage } from '@ja/portal/pageRegistry'

// Register dashboard pages
registerPage('portal-permissions', 'pages/Dashboard', () => import('../../Permissions/pages/Dashboard.vue'))
registerPage('portal-permissions', 'pages/RolesList', () => import('../../Permissions/pages/RolesList.vue'))
registerPage('portal-permissions', 'pages/RoleEditor', () => import('../../Permissions/pages/RoleEditor.vue'))
registerPage('portal-permissions', 'pages/AuditLog', () => import('../../Permissions/pages/AuditLog.vue'))
